import { Card } from "@lya-protect/lya-protect-form-library/dist/UI";
import styles from "./Dropdown.module.scss";
import { DropdownButton, DropdownButtonProps } from "./DropdownButton";

export function Dropdown({
  content,
  placement,
  children,
  icon,
  variant,
  className,
  dismissOnClick,
  ariaLabel,
}: DropdownButtonProps) {
  return (
    <DropdownButton
      content={content}
      placement={placement}
      icon={icon}
      variant={variant}
      className={className}
      withIcon={!!icon}
      dismissOnClick={dismissOnClick}
      ariaLabel={ariaLabel}
    >
      {(props) => (
        <Card className={styles.headerAction}>{children(props)}</Card>
      )}
    </DropdownButton>
  );
}
